// Local Constants
import { RESET_STATE } from '../auth/constants';
import {
    SPRAY_EVENT_WIZARD_SET_STEP,
    SPRAY_EVENT_WIZARD_SCHEDULE_STEP
} from './constants';

// Local Types
import { ResetStateAction } from '../auth/types';
import { SprayEventWizardState, SetSprayEventWizardStepAction } from './types';

const initialState: SprayEventWizardState = {
    step: SPRAY_EVENT_WIZARD_SCHEDULE_STEP
};

export default function (
    state: SprayEventWizardState = initialState,
    action: SetSprayEventWizardStepAction | ResetStateAction
): SprayEventWizardState {
    switch (action.type) {
        case SPRAY_EVENT_WIZARD_SET_STEP:
            return {
                step: action.payload
            };
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
